import React from 'react';
import '../styles/sections/clientList.scss';

const ClientList = (props) => {
    return(
        <div className="clientList whiteBg">
            <div className="innerBox lg">
                <div className="clientCat">
                    <h3>EDUCATION & HEALTHCARE</h3>
                    <ul>
                        <li>
                            <p>Hydrate you mobile iv</p>
                            <span>Ios app development and design</span>
                        </li>
                        <li>
                            <p>Knownow</p>
                            <span>Website Development, Website Design, app development (Ios/Android)</span>
                        </li>
                        <li>
                            <p>MGH</p>
                            <span>Ios app development & design</span>
                        </li>
                        <li>
                            <p>Every Doc</p>
                            <span>Website Development, Website Design app development (Ios / Android)</span>
                        </li>
                        <li>
                            <p>Mount Sinai</p>
                            <span>Ios app development</span>
                        </li>
                        <li>
                            <p>GST</p>
                            <span>Web application development & design</span>
                        </li>
                        <li>
                            <p>Northgate</p>
                            <span>Ios app development</span>
                        </li>
                        <li>
                            <p>BSSNY</p>
                            <span>Web application development & design</span>
                        </li>
                        <li>
                            <p>Columbia</p>
                            <span>Web application development & design</span>
                        </li>
                        <li>
                            <p>Pearson</p>
                            <span>Ios app development</span>
                        </li>
                        <li>
                            <p>Myaha</p>
                            <span>Web application development & design</span>
                        </li>
                    </ul>
                </div>
                <div className="clientCat">
                    <h3>Shopify</h3>
                    <ul>
                        <li>
                            <p>United by blue</p>
                            <span>Website Design</span>
                        </li>
                        <li>
                            <p>Mun</p>
                            <span>Website design custom theme level feature development</span>
                        </li>
                        <li>
                            <p>Arloskye</p>
                            <span>Website Design</span>
                        </li>
                        <li>
                            <p>MATCHABAR</p>
                            <span>Website Design</span>
                        </li>
                        <li>
                            <p>Mavi</p>
                            <span>Website design and development</span>
                        </li>
                        <li>
                            <p>ARMITRON</p>
                            <span>Custom theme level feature development</span>
                        </li>
                        <li>
                            <p>MAURICE LACROIX</p>
                            <span>Web application development & design</span>
                        </li>
                        <li>
                            <p>BEARMATTRESS</p>
                            <span>Website development</span>
                        </li>
                        <li>
                            <p>FLORISTS</p>
                            <span>Web design and development</span>
                        </li>
                        <li>
                            <p>BEAUTYRx</p>
                            <span>Web design and development</span>
                        </li>
                        <li>
                            <p>TODAYSLENS.COM</p>
                            <span>Web design and development</span>
                        </li>
                        <li>
                            <p>MY POOJA BOX</p>
                            <span>Website development and design</span>
                        </li>
                    </ul>
                </div>
                <div className="clientCat">
                    <h3>Mobile Applications</h3>
                    <ul>
                        <li>
                            <p>Hydrate you mobile iv</p>
                            <span>Ios app development and design</span>
                        </li>
                        <li>
                            <p>Knownow</p>
                            <span>Website Development, Website Design, app development (Ios/Android)</span>
                        </li>
                        <li>
                            <p>MGH</p>
                            <span>Ios app development & design</span>
                        </li>
                        <li>
                            <p>Every Doc</p>
                            <span>Website Development, Website Design app development (Ios / Android)</span>
                        </li>
                        <li>
                            <p>Mount Sinai</p>
                            <span>Ios app development</span>
                        </li>
                        <li>
                            <p>GST</p>
                            <span>Web application development & design</span>
                        </li>
                        <li>
                            <p>Northgate</p>
                            <span>Ios app development</span>
                        </li>
                        <li>
                            <p>CUNY</p>
                            <span>Admin development and design</span>
                        </li>
                        <li>
                            <p>Columbia</p>
                            <span>Web application development & design</span>
                        </li>
                    </ul>
                </div>
                <div className="clientCat">
                    <h3>Digital Marketing</h3>
                    <ul>
                        <li>
                            <p>United by blue</p>
                            <span>Website Design</span>
                        </li>
                        <li>
                            <p>Mun</p>
                            <span>Website design custom theme level feature development</span>
                        </li>
                        <li>
                            <p>Arloskye</p>
                            <span>Website Design</span>
                        </li>
                        <li>
                            <p>THE MAN COMPANY</p>
                            <span>Website Development, Website Design, Custom theme level feature development</span>
                        </li>
                        <li>
                            <p>MATCHABAR</p>
                            <span>Website Design</span>
                        </li>
                        <li>
                            <p>Mavi</p>
                            <span>Website design and development</span>
                        </li>
                        <li>
                            <p>ARMITRON</p>
                            <span>Custom theme level feature development</span>
                        </li>
                        <li>
                            <p>MAURICE LACROIX</p>
                            <span>Web application development & design</span>
                        </li>
                        <li>
                            <p>BEARMATTRESS</p>
                            <span>Website development</span>
                        </li>                        
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ClientList;